import React from 'react';

const VideoIcon = ({showNewUI = false, fillColor = '#2d2756', size = '40'}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 18 16"
      fill="none">
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M9.442 15.017H4.175c-2.633 0-3.508-1.75-3.508-3.509V4.492c0-2.634.875-3.509 3.508-3.509h5.267c2.633 0 3.508.875 3.508 3.509v7.016c0 2.634-.883 3.509-3.508 3.509ZM15.267 12.25l-2.317-1.625V5.367l2.317-1.625c1.133-.792 2.066-.309 2.066 1.083v6.35c0 1.392-.933 1.875-2.066 1.075Z"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M8.583 7.167a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      />
    </svg>
  ) : (
    <svg
      id="Video"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_708"
        data-name="Ellipse 708"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <path
        id="Path_65857"
        data-name="Path 65857"
        d="M243.619,34.837a4.982,4.982,0,0,1-5.019-4.931V5.071A4.982,4.982,0,0,1,243.619.14h24.638a4.983,4.983,0,0,1,5.026,4.931V29.906a4.983,4.983,0,0,1-5.026,4.931Zm0-31.932a2.185,2.185,0,0,0-2.2,2.165V29.906a2.178,2.178,0,0,0,2.2,2.158h24.638a2.185,2.185,0,0,0,2.2-2.158V5.071a2.185,2.185,0,0,0-2.2-2.165Zm42.7,30.191a1.392,1.392,0,0,1-.687-.189l-7.793-4.438a1,1,0,0,1-.371-1.349l.371-.634a1.061,1.061,0,0,1,.913-.519,1.03,1.03,0,0,1,.522.142l5.061,2.867h.192l.3-.169.1-.169V6.379l-.1-.162-.3-.175h-.192l-5.122,2.873a1.04,1.04,0,0,1-1.373-.371l-.391-.675a.97.97,0,0,1-.1-.749.987.987,0,0,1,.467-.6l7.766-4.4a1.5,1.5,0,0,1,.755-.223h.1a1.4,1.4,0,0,1,1.318,1.383v28.33a1.455,1.455,0,0,1-1.428,1.484Z"
        transform="translate(-227.766 18.006)"
        fill={fillColor}
      />
    </svg>
  );

export default VideoIcon;
